var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightTabbarMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "light_tabbar_market") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-63, -17)",
    stroke: "#0E1C39",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(66, 20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.32,0.762102355 L21.0723048,5.23789764 C21.8891237,5.70948822 22.3923048,6.58102355 22.3923048,7.52420471 L22.3923048,16.4757953 C22.3923048,17.4189764 21.8891237,18.2905118 21.0723048,18.7621024 L13.32,23.2378976 C12.5031812,23.7094882 11.4968188,23.7094882 10.68,23.2378976 L2.92769515,18.7621024 C2.11087631,18.2905118 1.60769515,17.4189764 1.60769515,16.4757953 L1.60769515,7.52420471 C1.60769515,6.58102355 2.11087631,5.70948822 2.92769515,5.23789764 L10.68,0.762102355 C11.4968188,0.290511777 12.5031812,0.290511777 13.32,0.762102355 Z",
    id: "\\u591A\\u8FB9\\u5F62"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5.53846154,
    x2: 12,
    y2: 18.4615385,
    id: "\\u8DEF\\u5F84-2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.38461538,
    y1: 10.1538462,
    x2: 7.38461538,
    y2: 15.6923077,
    id: "\\u8DEF\\u5F84-2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.6153846,
    y1: 8.30769231,
    x2: 16.6153846,
    y2: 15.6923077,
    id: "\\u8DEF\\u5F84-2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTabbarMarket);
export default __webpack_public_path__ + "static/media/light_tabbar_market.e569a642e7b9bc6b0b8a5ba7b5b787c8.svg";
export { ForwardRef as ReactComponent };